import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { AppShell } from './layout/AppShell'

const HomePage = lazy(() => import('./pages/HomePage'))
const PortfolioPage = lazy(() => import('./pages/PortfolioPage'))
const MarketsPage = lazy(() => import('./pages/MarketsPage'))
const AssetPage = lazy(() => import('./pages/AssetPage'))
const CardsPage = lazy(() => import('./pages/CardsPage'))
const PaymentsPage = lazy(() => import('./pages/PaymentsPage'))
const AnalyticsPage = lazy(() => import('./pages/AnalyticsPage'))
const ActivityPage = lazy(() => import('./pages/ActivityPage'))
const MorePage = lazy(() => import('./pages/MorePage'))
const SettingsPage = lazy(() => import('./pages/SettingsPage'))
const WelcomePage = lazy(() => import('./pages/WelcomePage'))
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'))
const AdministratorPage = lazy(() => import('./pages/AdministratorPage'))

function RouteFallback() { return <div className="route-skeleton" aria-label="Loading page"><span/><span/><span/><i/></div> }

export default function App() {
  return <Suspense fallback={<RouteFallback/>}><Routes>
    <Route path="/welcome" element={<WelcomePage/>}/>
    <Route path="/administrator" element={<AdministratorPage/>}/>
    <Route element={<AppShell/>}>
      <Route index element={<HomePage/>}/>
      <Route path="portfolio" element={<PortfolioPage/>}/>
      <Route path="markets" element={<MarketsPage/>}/>
      <Route path="asset/:id" element={<AssetPage/>}/>
      <Route path="cards" element={<CardsPage/>}/>
      <Route path="payments" element={<PaymentsPage/>}/>
      <Route path="analytics" element={<AnalyticsPage/>}/>
      <Route path="activity" element={<ActivityPage/>}/>
      <Route path="more" element={<MorePage/>}/>
      <Route path="settings" element={<SettingsPage/>}/>
      <Route path="search" element={<Navigate to="/markets" replace/>}/>
      <Route path="*" element={<NotFoundPage/>}/>
    </Route>
  </Routes></Suspense>
}

